import ServicesTransportFilter from "../../../../components/filteration/ServiceTransport";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import BackArrow from "../../../../components/backArrow";
import ShopAdds from "../../../../components/shopAds/ShopAdds";
import Shops from "../../../../components/Multipleshopprofile/Components/Shops/Shops";
import { ShopContext } from "../../../../config/shopContext";
import { 
  useLazyGetFilteredTransportVehiclesQuery, 
  useLazyGetShopCategoriesQuery 
} from "../../../../features/shop/shopApiSlice";
import "./transportFilter.css";

const TransportFilter = () => {
  const shopType = "transportVehicle";
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  const [triggerGetVehicles] = useLazyGetFilteredTransportVehiclesQuery();
  const [triggerGetCategories] = useLazyGetShopCategoriesQuery();

  const [isloading, setIsloading] = useState(false);
  const [shopCategory, setShopCategory] = useState([]);
  const [shopCategoryTwo, setShopCategoryTwo] = useState([]);
  const [showmodal, setShowmodal] = useState(false);
  const [dataCategory, setDataCategory] = useState({ categoryid: "" });

  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);
  const [filters, setFilters] = useState(
    currentData.additionalData || {
      shopid: "",
      shopname: "",
      shopCategory: "",
      brandName: "",
      model: "",
      min: "",
      max: "",
      country: "",
      state: "",
      city: "",
      categoryid: "",
    },
  );

  const handleShow = () => setShowmodal(true);

  const HandleData = (e) => {
    setDataCategory((prev) => ({
      ...prev,
      [e.target.name]: e.target.value.split("."),
    }));
  };

  const HandleShop = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const HandleItem = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const categoryName = dataCategory?.categoryid?.[1];
  const categoryidOne = dataCategory?.categoryid?.[0];

  useEffect(() => {
    setFilters((prev) => ({ ...prev, categoryid: categoryidOne || "" }));
  }, [categoryidOne]);

  // Fetch categories
  useEffect(() => {
    triggerGetCategories({ type: "transport", parentCategory: "" })
      .unwrap()
      .then((res) => res?.success && setShopCategory(res.data.Category))
      .catch(() => {});

    triggerGetCategories({ type: "transport", parentCategory: "true" })
      .unwrap()
      .then((res) => res?.success && setShopCategoryTwo(res.data.Category))
      .catch(() => {});
  }, [triggerGetCategories]);

  const MyData = () => {
    triggerGetCategories({ type: "transportVehicle", parentCategory: categoryName })
      .unwrap()
      .then((res) => res?.success && setShopCategoryTwo(res.data.Category))
      .catch((err) => console.log(err));
  };

  // Build query from current filters
  const buildQuery = (type) => {
    let query = { businessType: shopType, filtermethod: type };
    const keys =
      type === "shop"
        ? ["shopid", "shopname", "shopCategory", "categoryid"]
        : [
            "brandName",
            "model",
            "min",
            "max",
            "country",
            "state",
            "city",
            "categoryid",
          ];

    keys.forEach((k) => {
      if (filters[k] && filters[k].toString().trim() !== "")
        query[k] = filters[k].trim();
    });

    // Fix backend mapping: backend expects shopCategory for shops, but frontend uses categoryid
    if (type === "shop" && query.categoryid && !query.shopCategory) {
      query.shopCategory = query.categoryid;
      delete query.categoryid;
    }

    return query;
  };

  // Search shops
  const FilterHandler = () => {
    setIsloading(true);

    // Do not reset filters before building query!
    const query = buildQuery("shop");
    triggerGetVehicles(query)
      .unwrap()
      .then((res) => {
        setIsloading(false);
        if (res?.success) {
          setShopdata(res.Shop || []);
          setItemmdata(res.transportVehicle || []);
          updateFilteredData(
            shopType,
            res.Shop || [],
            res.transportVehicle || [],
            filters,
          );
        }
      })
      .catch(() => setIsloading(false));
  };

  // Search items/vehicles
  const FilterHandlerItem = () => {
    setIsloading(true);

    const query = buildQuery("transportvehicle");
    triggerGetVehicles(query)
      .unwrap()
      .then((res) => {
        setIsloading(false);
        if (res?.success) {
          setShopdata(res.Shop || []);
          setItemmdata(res.transportVehicle || []);
          updateFilteredData(
            shopType,
            res.Shop || [],
            res.transportVehicle || [],
            filters,
          );
        }
      })
      .catch(() => setIsloading(false));
  };

  return (
    <Container>
      <BackArrow back="/BuyingSide" mystyle="transport-filter-mobile-back d-lg-none" />
      <Row className="transport-filter-row">
        <Col lg="4" className="screenHeight">
          <div className="border b-radius height_100 background-image">
            <ServicesTransportFilter
              shopCategory={shopCategory}
              shopCategorytwo={shopCategoryTwo}
              HandleData={HandleData}
              HandleShop={HandleShop}
              Handleitem={HandleItem}
              MyData={MyData}
              FilterHandler={FilterHandler}
              FilterJobDetails={FilterHandlerItem}
              additionalShopCategoryData={filters}
            />
          </div>
        </Col>
        <Col lg="8" className="screenHeight">
          <div className="border b-radius ps-2 pe-2">
            <BackArrow back="/BuyingSide" mystyle="ps-1 pt-1 d-none d-lg-block" />
            <ShopAdds />
            <Shops
              link="/buying-transport"
              title="Transport"
              data={0}
              handleShow={handleShow}
              shopdata={shopdata}
              itemmdata={itemmdata}
              isloading={isloading}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TransportFilter;
